/*
 * Ajaxify Cart
 */
window.onload = function(){

	Shopify.AjaxifyCart = (function($){

		var init = function(){
			$(document).ready(function(){
				const cart = $('#cart');
				$('form[action="/cart/add"]').submit(function(e){
					e.preventDefault();
					var t = $(this),
						 button = t.find('[type="submit"]'),
						 count = $('.cart-total');
					//Add to cart
					$.ajax({
						url: '/cart/add.js',
						dataType: 'json',
						type: 'post',
						data: t.serialize(),
						success: function(itemData){

							button.addClass('adding')
									.text(button.data('adding'))

							$.getJSON('/cart.js', function(e){
								setTimeout(function(){
									if(cart.length){
										cart.removeClass('empty').addClass('added');
										setTimeout(function(){
											cart.removeClass('added');
										}, 1000);
									}
									if(count.length){
										count.text('['+e.item_count+']');
									}
									button.removeClass('adding')
											.addClass('added')
											.text(button.data('added'))
									if(!$('body').hasClass('template-product')){
										setTimeout(function(){
											button.removeClass('added')
													.text(button.data('add'))
										}, 1000);
									}
								}, 500);
							});

						},
						error: function(XMLHttpRequest){
							var response = eval('(' + XMLHttpRequest.responseText + ')');
							response = response.description;
							if(response.slice(0,4) === 'All '){
								button.text(button.data('sold')).prop('disabled', true);
							}else{
								button.text(button.data('error')).prop('disabled', true).addClass('error');
								setTimeout(function(){
									button.text(button.data('add')).prop('disabled', false).removeClass('error');
								}, 1000);
							}
						}
					});
					return false;
				});
			});
		};
		return{
			init: function(params){
				//Configuration
				params = params || {};
				//Merging with defaults
				$.extend(params);
				//Action
				$(function(){
					init();
				});
			}
		}
	})(jQuery);
	Shopify.AjaxifyCart.init();
}
